export default "__VITE_ASSET__Bwo7E_oE__"